import { ForwardedRef, forwardRef, useImperativeHandle, useRef } from 'react';

import { BankCodesForAll, getOrganizationLogoForAll, getAllBankName } from '@revenuemarket/bank';
import { Flex } from '@revenuemarket/cds';
import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';
import { Image, Typography } from 'antd';

interface Props extends ICellRendererParams<any> {}

const AGGridBankRenderer = (
  { data, value, formatValue }: Props,
  ref: ForwardedRef<ICellRendererComp>,
) => {
  const organizationCode = data.organizationCode;
  const containerRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(
    ref,
    () => ({
      getGui: () => containerRef.current ?? document.body,
      refresh: () => true,
    }),
    [],
  );

  if (!organizationCode) {
    return null;
  }

  return (
    <Flex ref={containerRef} align="center" style={{ height: '100%', cursor: 'pointer' }}>
      <Flex align="center" gap={8}>
        <Image
          width={20}
          height={20}
          src={
            getOrganizationLogoForAll(organizationCode as BankCodesForAll)?.x2 ||
            'https://static.clobe.ai/image/etc-bank.png'
          }
          alt={organizationCode}
        />
        <Typography.Text>{getAllBankName(organizationCode as BankCodesForAll)}</Typography.Text>
      </Flex>
    </Flex>
  );
};

export default forwardRef(AGGridBankRenderer);
